<div class="container" *ngIf="paymentDetail">

  <div class="head-context">
    <div class="avatar-co">
      <img [src]="isSuccessful ? '/assets/images/payment-success-avatar.png' : '/assets/images/payment-failed-avatar.png'" alt="">
    </div>
    <h1 *ngIf="isSuccessful" class="title">Congratulations, You Made It.</h1>
    <div *ngIf="!isSuccessful" class="text-co">
      <h1 class="title failed">Purchase Failed</h1>
      <p class="desc">Payment Was Not Completed, Please Try Again.</p>
    </div>
  </div>

  <div class="info-list">
    <div class="info-item">
      <p class="info-title">Product Name:</p>
      <p class="info-value">{{paymentDetail.product_detail.name}}</p>
    </div>
    <div class="info-item" *ngIf="isSuccessful">
      <p class="info-title">Order ID:</p>
      <p class="info-value">#{{paymentDetail.order_code}}</p>
    </div>
    <div class="info-item">
      <p class="info-title">Amount:</p>
      <p class="info-value">{{paymentDetail.currency_detail.symbol}}{{paymentDetail.payable_amount | convertPrice}}</p>
    </div>
    <div class="info-item">
      <p class="info-title">Points:</p>
      <p class="info-value"></p>
    </div>
    <div class="info-item">
      <p class="info-title">Reward:</p>
      <p class="info-value"></p>
    </div>
  </div>

  <div class="alert-box" *ngIf="isSuccessful">
    <p class="alert-title">Stay Tuned</p>
    <p class="alert-context">We will Send Your Purchased Gift Card As Soon As The Provider Issues It.</p>
  </div>

  <div class="action-container">
    <a mat-button class="transparent-button" [routerLink]="['/']">Back to Home</a>
    <a *ngIf="isSuccessful" mat-button class="primary-button" [routerLink]="['/order-history']">Tracking Order</a>
    <a *ngIf="!isSuccessful" mat-button class="primary-button" [routerLink]="['/product', paymentDetail.product_detail.id, productUrlFriendlyName]">Try Again</a>
  </div>
  
</div>